import React from 'react';
import _ from 'lodash';

import Confirmation from './common/Confirmation';
import { messageUtility } from '../../utilities/messageUtility';
import {
  PERMISSION_GROUP_TYPE,
  PREFECTURE_GROUPS,
  PREFECTURE_LISTS,
} from '../../utilities/constants';
import { INDUSTRY } from '../../utilities/roanConstants';
import { getPermitTypeName } from '../../utilities/CompanySaftyLicenseUtil.js';

export const DeleteCompanyLicenseConfirmDialog = ({
  visible,
  data = [],
  onConfirm,
  onCancel,
  bureaux,
}) => {
  const getPrefectureName = id => {
    return `${_.get(PREFECTURE_LISTS, id) || ''}知事許可`;
  };

  const getBureauxName = bureauxId => {
    if (!bureauxId) {
      return '';
    }
    const data = _.find(bureaux, item => Number(item.id) === Number(bureauxId));
    if (!data) {
      return '';
    }
    return _.get(data, 'bureau_short_name');
  };

  const getContentCommonPermission = permission => {
    const {
      permitted_source_section,
      construction_industry_permission_section,
      prefectures_code_id,
      permission_number_l,
      permission_number_r,
      regional_development_bureau_id,
      authorized_industry_names,
    } = permission;
    const noData = '　';
    let permittedSourceSection = '';
    if (permitted_source_section === INDUSTRY.permissions.source[1].id) {
      permittedSourceSection = '大臣許可';
    } else if (permitted_source_section === INDUSTRY.permissions.source[2].id) {
      permittedSourceSection = getPrefectureName(prefectures_code_id);
    }
    const permissionNumberL = permission_number_l || noData;
    const permissionNumberR = permission_number_r || noData;
    const bureauxName = getBureauxName(regional_development_bureau_id);
    const permitTypeName = getPermitTypeName(
      construction_industry_permission_section
    );
    return `建設 ${permittedSourceSection}（${permitTypeName}-${permissionNumberL}） ${bureauxName} 第${permissionNumberR}号 ${authorized_industry_names}`;
  };

  const generateMessage = () => {
    return (
      <React.Fragment>
        <p className='description'>{messageUtility.getMessage('I-001-431')}</p>
        <ul className='detail__item'>
          {_.map(data, permission => {
            const {
              id,
              permission_group_type,
              authorized_industry_names,
              prefectures_code_id,
              permission_number_r,
            } = permission;
            let content = '';
            switch (permission_group_type) {
              case PERMISSION_GROUP_TYPE.common: {
                content = getContentCommonPermission(permission);
                break;
              }
              case PERMISSION_GROUP_TYPE.security: {
                let prefecturesName = '';
                _.forEach(PREFECTURE_GROUPS, ({ prefectures }) => {
                  const prefecture = _.find(prefectures, {
                    id: prefectures_code_id,
                  });
                  if (prefecture) {
                    prefecturesName = prefecture.name;
                    return false;
                  }
                });
                content = `警備 ${prefecturesName}公安委員会 第${permission_number_r}号`;
                break;
              }
              case PERMISSION_GROUP_TYPE.other: {
                content = `その他 第${permission_number_r}号 ${authorized_industry_names}`;
                break;
              }
            }
            return (
              <li key={id} className='detail__value'>
                {content}
              </li>
            );
          })}
        </ul>
        <p className='description'>{messageUtility.getMessage('I-001-432')}</p>
      </React.Fragment>
    );
  };

  return (
    <Confirmation
      visible={visible}
      title='許可情報の削除'
      rootClassName='DeleteCompanyLicenseConfirmDialog dialog--wide'
      message={generateMessage()}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      confirmButtonText={messageUtility.getMessage('I-001-433')}
      onConfirm={onConfirm}
      onCancel={onCancel}
      isNegative={true}
      multilineText={true}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/DeleteCompanyLicenseConfirmDialog.jsx